import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import app from './app';

export default persistReducer({
    key: 'adobe',
    storage,
  }, app);



// WEBPACK FOOTER //
// ./src/sub-projects/adobe/reducers/index.ts